import { render, staticRenderFns } from "./DeleteTagDialog.vue?vue&type=template&id=f62942bc"
import script from "./DeleteTagDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports